export default function WhyChooseUs() {
  const features = [
    {
      icon: "⚡",
      title: "Fast Turnaround",
      text: "Most custom orders completed within 24–48 hours.",
    },
    {
      icon: "🎨",
      title: "Premium DTF Printing",
      text: "Bright colours, soft feel and long-lasting prints.",
    },
    {
      icon: "👕",
      title: "Custom Apparel",
      text: "T-Shirts, Hoodies, Caps, Sportswear and more.",
    },
    {
      icon: "🚚",
      title: "Nationwide Delivery",
      text: "We deliver across South Africa.",
    },
  ];

  return (
    <section className="bg-[#0d1117] py-24 text-white">
      <div className="mx-auto max-w-7xl px-6">

        <h2 className="mb-4 text-center text-5xl font-black">
          WHY CHOOSE US
        </h2>

        <p className="mb-16 text-center text-gray-400">
          Quality printing. Professional service. Affordable prices.
        </p>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {features.map((item) => (
            <div
              key={item.title}
              className="rounded-3xl border border-sky-500/20 bg-slate-900 p-8 text-center transition duration-300 hover:-translate-y-2 hover:border-sky-400 hover:shadow-2xl hover:shadow-sky-500/20"
            >
              <div className="mb-5 text-6xl">{item.icon}</div>

              <h3 className="mb-4 text-2xl font-bold">
                {item.title}
              </h3>

              <p className="text-gray-400">
                {item.text}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}